/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufDurationFromJSON, GoogleProtobufDurationToJSON, } from './';
export function StreemApiAnalyticEventToolDrawFromJSON(json) {
    return StreemApiAnalyticEventToolDrawFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventToolDrawFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'duration': !exists(json, 'duration') ? undefined : GoogleProtobufDurationFromJSON(json['duration']),
    };
}
export function StreemApiAnalyticEventToolDrawToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'duration': GoogleProtobufDurationToJSON(value.duration),
    };
}
//# sourceMappingURL=StreemApiAnalyticEventToolDraw.js.map